import * as Yup from "yup";

export const signatureValidationSchema = Yup.object().shape({});
